import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../MotivosAbandono/actions'
import { Field } from 'redux-form'
import {
  renderSelectField
} from '../../fieldRenderers'

class MotivosAbandono extends Component {
  constructor (props) {
    super(props)
    this.renderMotivos = this.renderMotivos.bind(this)
    this.onSelect = this.onSelect.bind(this)
  };

  componentDidMount () {
    this.props.requestMotivosAbandono()
  };

  onSelect (motivoAbandono) {
    if (motivoAbandono) {
      this.props.setMotivoAbandono(motivoAbandono.target.value)
    }
  }

  renderMotivos () {
    const {
      motivosAbandono
    } = this.props

    const option = motivosAbandono && motivosAbandono.filas.map(motivoAbandono => {
      return (
        <option
          value={motivoAbandono.nombreCorto}
          key={motivoAbandono.nombreCorto}
        >
          {motivoAbandono.nombre}
        </option>
      )
    })
    option.unshift((<option value={null} key={0} />))
    return option
  };

  render () {
    const {
      isRequesting
    } = this.props

    return (
      <Field
        onChange={this.onSelect}
        name='motivoAbandono'
        label='Motivo de Abandono'
        component={renderSelectField}>
        {!isRequesting ? this.renderMotivos() : null}
      </Field>
    )
  }
}

const mapStateToProps = (state) => ({
  isRequesting: state.motivosAbandono.isRequestingMotivosAbandono,
  motivosAbandono: state.motivosAbandono.motivosAbandono
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(MotivosAbandono)
